/*
 * Author: Roger
 * File Created: Friday, 24-07-26 03:36 pm
 * Last Modified: Wednesday, 24-11-20 06:37 pm, by Roger
 */

// update from https://www.figma.com/design/w89XIcAJwfzL0E1KIJzPkq/DeCard%E8%A7%84%E8%8C%83?node-id=244-1214&node-type=canvas&m=dev
function Verified() {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" data-sentry-element="svg" data-sentry-component="Verified" data-sentry-source-file="index.tsx">
      <path fillRule="evenodd" clipRule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.1253 9.94727C17.4828 9.60194 17.4927 9.03218 17.1474 8.67467C16.802 8.31715 16.2323 8.30727 15.8748 8.6526L10.707 13.6442L8.15541 10.9331C7.81475 10.5711 7.24516 10.5539 6.8832 10.8946C6.52125 11.2352 6.50399 11.8048 6.84465 12.1668L9.76076 15.2651C10.2478 15.7826 11.0639 15.802 11.575 15.3083L17.1253 9.94727Z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="index.tsx" />
    </svg>;
}
export default Verified;